export const CELL_HORIZONTAL_PADDING = 9;
export const CELL_BORDER_WIDTH = 1;
